const api = {
	settleBills: '/mallSettlement/settleBills', // 确认结算账单
	listBills: '/mallSettlement/listBills', // 查询商户账单列表
	listBillDates: '/mallSettlement/listBillDates', // 查询结算周期列表
	listAllCouponBillMerchants: '/mallSettlement/listAllCouponBillMerchants', // 查询所有结算商户列表
	downloadBillDetail: '/mallSettlement/downloadBillDetail', // 下载结算明细
	getMallBillDetail: '/mallSettlement/getBillDetail', //查询商城结算明细
	// 查询商家账单列表（储值结算和卡券结算）
	listMerchantCouponAndStoredValueCardBills: '/storedValueCardSettlement/listMerchantCouponAndStoredValueCardBills',
	// 查询商家账单（储值结算和卡券结算）的周期列表
	listMerchantCouponAndStoredValueCardBillDates:
		'/storedValueCardSettlement/listMerchantCouponAndStoredValueCardBillDates',
	// 查询商家账单（储值结算和卡券结算）的结算主体列表
	listMerchantCouponAndStoredValueCardBillOrganizations:
		'/storedValueCardSettlement/listMerchantCouponAndStoredValueCardBillOrganizations',
	// 下载商家所有账单（储值结算和卡券结算）的结算明细
	downloadMerchantAllCouponAndStoredValueCardBillDetail:
		'/storedValueCardSettlement/downloadMerchantAllCouponAndStoredValueCardBillDetail',
	// 确认结算单
	confirmBill: '/storedValueCardSettlement/confirmBill',
	// 商家批量确认账单
	confirmBills: '/storedValueCardSettlement/confirmBills',
	// 下载所有结算明细
	downloadStoredBillDetail: '/storedValueCardSettlement/downloadBillDetail',
	judgeBillSetting: '/storedValueCardSettlement/judgeBillSetting',
};

const routes = {
	// '/mall-settlement': '对账结算',
	'/mall-settlement/bill': '对账单',
	'/mall-settlement/bill/detail': '对账明细',
	'/mall-settlement/settlement': '结算单',
};

export { api, routes };
